import React, { useEffect, useState } from 'react'
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import layout from 'antd/lib/layout'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { selectTenantId, selectChainId } from '../../app/applicationSlice'
import { DateSelect } from '../../compnents/form/DateSelect'
import styles from './appllication.module.css'
import {
  getChainListFn,
  getCopyDetailAcceptanceButtonAsync,
  getCopyDetailButtonAsync,
  getCopyListAsync,
  getPurchaseBusinessListFn,
} from './chainSlice'
import { SearchOutlined } from '@ant-design/icons'
import { stringTrim } from '../../utils/StringUtils'
import { EditableList } from '../../compnents/list/EditableList'
import { CopyCGYWColumns, CopyColumns } from './columns'
import { TableRowSelection } from 'antd/lib/table/interface'
import { CGDDetailModal } from './CGDDetailModal'
import { Category } from '../../models/category'

export const CopyCGYWModal = (props: {
  detail?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
  refresh: () => void
  storehouseTag?: any
  targetInventoryReceiptsId?: any
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const [inventoryReceiptsId, setInventoryReceiptsId] = useState<any>()

  const [detailModalVisible, setDetailModalVisible] = useState(false)

  const [chainList, setChainList] = useState<any>([])

  const [selectIds, setSelectIds] = useState<any>([])

  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectIds(selectedRowKeys)
    },
  }
  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  useEffect(() => {
    if (props?.visible) {
      dispatch(getChainListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.branchList)
        })
    } else {
      setSelectIds([])
      form.resetFields()
      setParams({
        current: 1,
        size: 10,
      })
    }
  }, [props?.visible])

  useEffect(() => {
    if (props?.visible) {
      dispatch(
        getPurchaseBusinessListFn({
          ...params,
          // qurryBranchData: true,
          category: Category.CGYW,
          supplierName: props?.detail?.supplierName,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          const data = {
            total: res.total,
            items: res.records,
          }
          setPage(data)
        })
    }
  }, [props?.visible, params])

  return (
    <>
      <Modal
        title='复制采购单'
        width={1200}
        visible={props?.visible}
        className={styles.copyTBDModal}
        onCancel={() => {
          form.resetFields()
          props?.onCancel()
        }}
        footer={null}
        centered
      >
        <div>
          <Form
            form={form}
            {...layout}
            style={{ paddingRight: 10 }}
            onFinish={(v) => {
              setParams({
                ...params,
                ...v,
                current: 1,
                recepitsDateStart: v?.timeHead ? v?.timeHead : undefined,
                recepitsDateEnd: v?.timeTail ? v?.timeTail : undefined,
                timeHead: undefined,
                timeTail: undefined,
              })
            }}
          >
            <Row style={{ marginBottom: 16 }} justify='space-between'>
              <Space>
                <Form.Item
                  name='putNumber'
                  getValueFromEvent={stringTrim}
                  noStyle
                >
                  <Input
                    placeholder='输入业务单号'
                    allowClear
                    style={{ width: '150px' }}
                    prefix={<SearchOutlined />}
                    onChange={form.submit}
                  />
                </Form.Item>
                <Form.Item name='storehouseTag' noStyle>
                  <Select
                    placeholder='状态'
                    dropdownClassName={styles.select}
                    style={{ width: '120px' }}
                    onChange={form.submit}
                    allowClear
                  >
                    <Option value='206'>待提交</Option>
                    <Option value='207'>待审核</Option>
                    <Option value='208'>审核不通过</Option>
                    <Option value='209'>审核通过</Option>
                    <Option value='210'>已上传</Option>
                  </Select>
                </Form.Item>
                <Form.Item name='recepitsDate' noStyle>
                  <DateSelect
                    placeholder='创建日期'
                    style={{ width: '7rem' }}
                    labelPrefix=''
                    onChange={form.submit}
                    namePrefix='time'
                  />
                </Form.Item>
                <Button type='primary' htmlType='submit'>
                  查询
                </Button>
              </Space>
              <Space>
                <Button
                  type='primary'
                  onClick={() => {
                    if (!selectIds?.length) {
                      notification.info({
                        message: '请先选择要复制的调拨单',
                      })
                    } else {
                      // 复制
                      dispatch(
                        getCopyDetailAcceptanceButtonAsync({
                          sourceInventoryReceiptsIds: selectIds,
                          targetInventoryPurchAseacceptanceId:
                            props?.detail?.id,
                        })
                      )
                        .then(unwrapResult)
                        .then((res: any) => {
                          notification.success({
                            message: '复制成功',
                          })
                          props?.refresh()
                        })
                    }
                  }}
                >
                  复制明细
                </Button>
              </Space>
            </Row>
          </Form>

          <EditableList
            style={{ height: '450px',overflow: 'auto' }}
            scroll={{ x: '30rem' }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            pageSizeOptions={['10', '20', '50', '100']}
            rowKey={(m: any) => m.id}
            rowSelection={
              {
                selectedRowKeys: selectIds,
                ...rowSelection,
              } as TableRowSelection<any>
            }
            columns={CopyCGYWColumns(
              params.size * (params.current - 1),
              (action: any, t: any) => {
                switch (action) {
                  case 'detail':
                    setDetailModalVisible(true)
                    setInventoryReceiptsId(t?.id)
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, current, size: size || 10 })
            }
            onRow={(d) => ({
              onClick: (e) => {
                e.stopPropagation()
                if(selectIds.includes(d?.id)) {
                  setSelectIds(selectIds.filter((id: any) => id !== d?.id))
                } else {
                  setSelectIds([...selectIds, d?.id])
                }
              },
            })}
            sticky
          />
        </div>
      </Modal>
      <CGDDetailModal
        visible={detailModalVisible}
        category={Category.YSYW}
        inventoryReceiptsId={inventoryReceiptsId}
        storehouseTag={props?.storehouseTag}
        onCancel={() => {
          setDetailModalVisible(false)
          setInventoryReceiptsId('')
        }}
        onOk={() => {
          setDetailModalVisible(false)
          setInventoryReceiptsId('')
        }}
      ></CGDDetailModal>
    </>
  )
}
